



























































































import { Component } from 'vue-property-decorator';
import GiganautVue from '@/components/Shared/GiganautVue';
import { AgencySettingsModule } from '@/store/modules/agencySettings';
import ReportingPeriodDto from '@/models/ReportingPeriods/ReportingPeriodDto';
import ReportingPeriodCreate from './ReportingPeriodCreate.vue';
import ReportingPeriodEdit from './ReportingPeriodEdit.vue';
import ReportingPeriodGenerate from './ReportingPeriodGenerate.vue';
import { getFiscalYearOptions } from '@/lib/fiscalYears';

@Component({
	name: 'ReportingPeriods',
	components: { ReportingPeriodCreate, ReportingPeriodEdit, ReportingPeriodGenerate }
})
export default class extends GiganautVue {
	showDeleteDialog = false;
	fiscalYearFilter: number | null = null;

	get reportingPeriods() {
		return AgencySettingsModule.reportingPeriods;
	}

	get currentReportingPeriod() {
		return AgencySettingsModule.currentReportingPeriod;
	}

	get fiscalYearItems() {
		return getFiscalYearOptions();
	}

	selectPeriod(period: ReportingPeriodDto) {
		AgencySettingsModule.updateCurrentReportingPeriod(period);
	}

	onFiscalYearChanged() {
		if (this.fiscalYearFilter) {
			AgencySettingsModule.getReportingPeriods(this.fiscalYearFilter);
		} else {
			AgencySettingsModule.getReportingPeriods();
		}
	}

	onCreated() {
		// Re-fetch to ensure fresh data
	}

	onUpdated() {
		// Re-fetch to ensure fresh data
	}

	onGenerated() {
		// Data is already updated via the store
	}

	confirmDelete() {
		this.showDeleteDialog = true;
	}

	async deletePeriod() {
		if (this.currentReportingPeriod) {
			await AgencySettingsModule.deleteReportingPeriod(this.currentReportingPeriod.id);
		}
		this.showDeleteDialog = false;
	}

	formatDate(dateStr: string) {
		if (!dateStr) return '-';
		return dateStr.substring(0, 10);
	}
}
